module.exports = __webpack_public_path__ + "static/media/2_2_graceann_bennett.eaaed0b.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/2_2_graceann_bennett.mp3
// module id = PtMZ
// module chunks = 1